import React, {useRef, useState} from "react";
import {Alert, Button, Descriptions, message, Modal} from "antd";
import accountApi from "../../accounts/accounts.service";

export function AdminOtpModal({modalState, setModalState, setForceReload}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const submitting = useRef(false);
  const admin = modalState.modalData;
  const isDelete = modalState.modalType === "otpDelete";
  const action = isDelete ? "삭제" : modalState.modalType === "otpCreate" ? "생성" : "초기화";

  const close = () => {
    if (submitting.current) return;
    setModalState({isVisible: false, modalData: {}, modalType: ""});
  };

  const submit = async () => {
    if (submitting.current) return;
    submitting.current = true;
    setLoading(true);
    setError("");
    try {
      if (isDelete) {
        await accountApi.deleteAdminOtp(admin.id);
      } else {
        await accountApi.resetAdminOtp(admin.id);
      }
      message.success(isDelete ? "OTP를 삭제했습니다." : `OTP ${action} 및 등록 메일 발송을 요청했습니다.`);
      setModalState({isVisible: false, modalData: {}, modalType: ""});
      setForceReload();
    } catch (err) {
      const status = err?.response?.status;
      setError(status === 403
        ? "해당 관리자의 OTP를 관리할 권한이 없습니다."
        : status === 404
          ? "관리자 계정을 찾을 수 없습니다. 목록을 새로고침해주세요."
          : isDelete
            ? "OTP 삭제 결과를 확인하지 못했습니다. 목록을 새로고침해 상태를 확인해주세요."
            : `OTP ${action} 결과를 확인하지 못했습니다. 대상자의 메일 수신 여부를 확인한 후 다시 시도해주세요.`);
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isDelete ? "OTP 삭제" : `OTP ${action} 메일 전송`}
      visible={modalState.isVisible}
      onCancel={close}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
      footer={[
        <Button key="cancel" onClick={close} disabled={loading}>취소</Button>,
        <Button key="submit" danger type="primary" loading={loading} disabled={loading} onClick={submit}>
          {isDelete ? "삭제" : `${action} 및 메일 전송`}
        </Button>,
      ]}
    >
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="이름">{admin.name}</Descriptions.Item>
        <Descriptions.Item label="이메일">{admin.email}</Descriptions.Item>
        <Descriptions.Item label="소속 밴드">{admin.band?.name || "없음"}</Descriptions.Item>
      </Descriptions>
      <Alert
        style={{marginTop: 16}}
        type="warning"
        showIcon
        message={isDelete
          ? "OTP를 삭제하면 OTP 인증 없이 로그인할 수 있습니다."
          : action === "생성" ? "새 OTP를 생성합니다." : "기존 OTP는 더 이상 사용할 수 없습니다."}
        description={isDelete
          ? "대상 계정의 OTP 등록을 해제합니다. 기존 OTP는 더 이상 사용할 수 없으며, 비밀번호는 변경되지 않습니다."
          : "위 이메일로 새 인증 앱 등록 링크를 보냅니다. 대상자는 인증 앱에 등록한 뒤 기존 비밀번호와 새 OTP로 로그인할 수 있습니다. 비밀번호는 변경되지 않습니다."}
      />
      {error && <Alert style={{marginTop: 16}} type="error" showIcon message={error}/>}
    </Modal>
  );
}
